// extracted by mini-css-extract-plugin
module.exports = {"select":"NumberSelectForm-module__select___2X9Fe"};